<template>
<div class="about">
  <h2>Steam</h2>

  <p>Click the below button to login with your Steam account.</p>

  <a href="https://mighty-reef-20023.herokuapp.com/steam/login"><img src="img/sits_02.png" /></a>

  <p v-if="authenticated == true">Your Steam ID: {{ authenticationData.steamId }}</p>
</div>
</template>

<script>
import Vue from 'vue'
import VueResource from 'vue-resource'

Vue.use(VueResource)

export default {
  data: function() {
    return {
      authenticated: false,
      steamId: '',
      authenticationData: {}
    }
  },
  created: function() {
    var query = this.$route.query
    var openidNs = this.$route.query["openid.ns"]
    if (openidNs != undefined) {
      Vue.http.get('https://mighty-reef-20023.herokuapp.com/steam/authenticate' + '?' + Object.entries(query).map(e => e.join('=')).join('&'))
        .then(response => {
          this.authenticationData = response.data
          this.authenticated = true
        })
    }
  }
}
</script>

<style scoped>
h1,
h2 {
  padding-top: 20px;
  font-weight: normal;
}
</style>
